import "./index.scss";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";

export const PrimaryCheckout = () => {
  return (
    <div className="primary-checkout">
      <ReactHelmetWithProvider>
        <title>GCX: Checkout</title>
        <meta name="robots" content="noindex" />
      </ReactHelmetWithProvider>
      primary-checkout
    </div>
  );
};
